import { reactive, readonly } from 'vue';

const alert = reactive({
  isVisible: false,
  type: '',
  message: ''
});

let resetMessage;

export default function useFlashMessage() {
  /**
   * フラッシュメッセージを閉じる
   */
  const onClose = () => {
    alert.isVisible = false;
  };

  /**
   * フラッシュメッセージを表示
   *
   * @param {string} type
   * @param {string} message
   * @param retention
   */
  const showFlashMessage = (type, message, retention = 6000) => {
    clearTimeout(resetMessage);

    alert.isVisible = true;
    alert.type = type;
    alert.message = message;

    resetMessage = setTimeout(() => {
      alert.isVisible = false;
      alert.type = '';
      alert.message = '';
    }, retention);
  };

  /**
   * 成功のフラッシュメッセージを表示
   *
   * @param message
   * @param retention
   */
  const successMessage = (message, retention) => {
    return showFlashMessage('success', message, retention);
  };

  /**
   * 警告のフラッシュメッセージを表示
   *
   * @param message
   * @param retention
   */
  const warningMessage = (message, retention) => {
    return showFlashMessage('warning', message, retention);
  };

  /**
   * エラーのフラッシュメッセージを表示
   *
   * @param message
   * @param retention
   */
  const errorMessage = (message, retention) => {
    return showFlashMessage('danger', message, retention);
  };

  return {
    alert: readonly(alert),
    showFlashMessage,
    successMessage,
    warningMessage,
    errorMessage,
    onClose
  };
}
